import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {ButtonMover} from 'shells/button-mover/button-mover';

type Props = {
    onCancel: () => void;
    onCreate: () => void;
    userFacingNoun: string;
    isCreating?: boolean;
    errorMessage?: string | null | undefined;
};

export function EditionCreationFooter(props: Props) {
    return (
        <div className='flex justify-sb align-center'>
            <ButtonMover size='big' direction='left'>
                <Button variant='text-secondary' onClick={() => props.onCancel()} size='big'>
                    Cancel
                </Button>
            </ButtonMover>
            <SaveButton
                isSaving={props.isCreating || false}
                // @ts-expect-error
                onClick={() => props.onCreate()}
                buttonText={`Create ${props.userFacingNoun}`}
                savingText='Creating…'
                errorSaving={Boolean(props.errorMessage)}
            />
        </div>
    );
}
